/* eslint-disable react/require-default-props */
import React, { useCallback, useEffect, useState } from 'react'
import { formatDecimalsHelper } from '@qirapagos/lib/utils/common'
import { LocalStorage } from 'constants/localStorage'
import EyeShowPassword from '@qirapagos/lib/assets/svg/EyeShowPassword'
import EyeSlashPassword from '@qirapagos/lib/assets/svg/EyeSlashPassword'
import { moneySymbol } from '@qirapagos/lib/constants/common'
import ButtonLine from 'components/atoms/ButtonLine'
import { useAppSelector } from 'hooks/redux'
import {
  Container,
  Title,
  Subtitle,
  AmountContainer,
  BalanceWithNoDecimals,
  BalanceDecimals,
  EyeButton,
  HeaderContainer,
  RightContainer,
  CustomButton,
  BottomContainer,
  InvestmentButton
} from './style'
import CopyClipboard from 'assets/svg/Copy'

interface Props {
  title: string
  subtitle?: string
  buttonText: string
  showCopyIcon?: boolean
  showEyeButton?: boolean
  width?: string | number
  height?: string | number
  action?: string
  disabledAction?: boolean
  onPressButton: () => void
  onPressAction?: () => void
}

const Balance: React.FC<Props> = ({
  title,
  subtitle,
  buttonText,
  showCopyIcon = false,
  showEyeButton = false,
  width,
  height,
  action,
  disabledAction = false,
  onPressButton,
  onPressAction
}) => {
  const { balance } = useAppSelector(state => state.transfers)
  const [showPassword, setShowPassword] = useState(
    localStorage.getItem(LocalStorage.SHOW_PASSWORD) === 'true'
  )
  const { balanceWithNoDecimals, decimals } = formatDecimalsHelper(balance)

  const showAmount = useCallback(() => {
    const newValue = !showPassword
    setShowPassword(newValue)
    localStorage.setItem(LocalStorage.SHOW_PASSWORD, String(newValue))

    window.dispatchEvent(new CustomEvent('password-visibility-changed'))
  }, [showPassword])

  useEffect(() => {
    const handler = () => {
      setShowPassword(localStorage.getItem(LocalStorage.SHOW_PASSWORD) === 'true')
    }

    window.addEventListener('password-visibility-changed', handler)

    return () =>
      window.removeEventListener('password-visibility-changed', handler)
  }, [])

  const Amount = (
    <>
      <BalanceWithNoDecimals>
        {moneySymbol}
        {balanceWithNoDecimals}
      </BalanceWithNoDecimals>
      <BalanceDecimals>{decimals}</BalanceDecimals>
    </>
  )

  return (
    <Container style={{ width, height }}>
      <HeaderContainer>
        <Title>{title}</Title>
        <RightContainer>
          {showCopyIcon
            ? (
              <>
                <CopyClipboard width={18} height={18} />
                <CustomButton onClick={onPressButton}>{buttonText}</CustomButton>
              </>
              )
            : (
              <ButtonLine onPress={onPressButton} isBig={false}>
                {buttonText}
              </ButtonLine>
              )}
        </RightContainer>
      </HeaderContainer>
      <Subtitle>{subtitle}</Subtitle>
      <AmountContainer>
        {showPassword
          ? (
              Amount
            )
          : (
            <BalanceWithNoDecimals>**********</BalanceWithNoDecimals>
            )}
        {showEyeButton && (
          <EyeButton onClick={showAmount}>
            {showPassword ? <EyeShowPassword /> : <EyeSlashPassword />}
          </EyeButton>
        )}
      </AmountContainer>
      {action && (
        <BottomContainer>
          <InvestmentButton
            $disabled={disabledAction}
            onClick={disabledAction ? undefined : onPressAction ?? onPressButton}
          >
            {action}
          </InvestmentButton>
        </BottomContainer>
      )}
    </Container>
  )
}

export default Balance
